import { render } from "./top_menu_group.vue?vue&type=template&id=0b0f6892&scoped=true"
import script from "./top_menu_group.vue?vue&type=script&lang=js"
export * from "./top_menu_group.vue?vue&type=script&lang=js"

import "./top_menu_group.vue?vue&type=style&index=0&id=0b0f6892&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./top_menu_group.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0f6892"]])

export default __exports__